import React from 'react';

type RadioInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
};

export const RadioButton = React.forwardRef<HTMLInputElement, RadioInputProps>((props, ref) => {
  const { label, ...radioProps } = props;
  const id = props.id || props.name + '-' + props.value;
  return (
    <span>
      <input type="radio" id={id} ref={ref} {...radioProps} />
      <label className={'ml-2 text-[--c-text]'} htmlFor={id}>
        {label}
      </label>
    </span>
  );
});
RadioButton.displayName = 'RadioButton';
